import api from "./api";

export type PushSubscriptionPayload = {
  endpoint: string;
  keys: {
    p256dh: string;
    auth: string;
  };
};

const base64UrlEncode = (buffer: ArrayBuffer | null) => {
  if (!buffer) return "";
  const bytes = new Uint8Array(buffer);
  let binary = "";
  for (let i = 0; i < bytes.length; i += 1) {
    binary += String.fromCharCode(bytes[i]);
  }
  return btoa(binary).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/g, "");
};

const normalizeSubscription = (subscription: PushSubscription): PushSubscriptionPayload => {
  const fromJson = typeof subscription.toJSON === "function"
    ? (subscription.toJSON() as PushSubscriptionPayload)
    : (subscription as unknown as PushSubscriptionPayload);

  const endpoint = fromJson?.endpoint || subscription.endpoint;
  const keys = fromJson?.keys || {};
  const p256dh = keys.p256dh || base64UrlEncode(subscription.getKey("p256dh"));
  const auth = keys.auth || base64UrlEncode(subscription.getKey("auth"));

  return {
    endpoint,
    keys: {
      p256dh,
      auth,
    },
  };
};

export const suscribirPush = async (
  subscription: PushSubscription,
  meta?: { plataforma?: string; user_agent?: string }
) => {
  const payload = normalizeSubscription(subscription);

  return api.post("push/suscribir", {
    subscription: payload,
    plataforma: meta?.plataforma,
    user_agent: meta?.user_agent,
  });
};

export const estadoPush = async () => {
  return api.get("push/estado");
};

export const desuscribirPush = async (subscription: PushSubscription) => {
  const payload = normalizeSubscription(subscription);

  return api.post("push/desuscribir", { subscription: payload });
};
